import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { AGSSpinSchema, HoldAndSpinSchema } from "ags/integration/schema/ags-spin-response-schema";
import { getReelIndexFromCoordinate } from "ags/utils/flat-matrix-conversion";

class MCPickRecordGridGenerator {

    private reelHeight = 3;

    public getNewGrid(spinRecord: SpinRecord, spin: AGSSpinSchema, reelset: string[][]) {
        const randomGrid = this.getRandomGrid(reelset);

        this.updateGridWithMcSymbols(spinRecord, spin, randomGrid);

        return randomGrid;
    }

    public getMostRecentChildFeatures(spinRecord: SpinRecord, childFeature: HoldAndSpinSchema[]) {
        const pickRecords = childFeature.filter((child) => child.type === "pick");
        const children = [];
        const startIndex = this.getIndexOfSecondGame(pickRecords);

        if (this.isFirstPickBonus(spinRecord)) {
            return pickRecords;
        }

        for (let i = startIndex; i < pickRecords.length; i++) {
            children.push(pickRecords[i]);
        }

        return children;
    }

    public getSpinsRemaining(spinRecord: SpinRecord, childFeatures: HoldAndSpinSchema[]) {
        let spinsRemaining = 3;

        const relevantChildFeatures = this.getMostRecentChildFeatures(spinRecord, childFeatures);

        relevantChildFeatures.forEach((pickData) => {
            spinsRemaining --;
            if (pickData.MCSymbols.length > 0) {
                spinsRemaining = 3;
            }
        });

        return spinsRemaining;
    }

    public getRandomGrid(reelset: string[][]) {
        const validSymbols = ["H1", "H2", "H3", "H4", "H5", "L1", "L2", "L3", "L4", "L5", "L6"];
        const numberOfReels = reelset.length;
        const randomGrid: string[][] = [];

        for (let i = 0; i < numberOfReels; i++) {
            const RandomSymbol = validSymbols[Math.floor(Math.random() * validSymbols.length)];
            randomGrid[i] = [RandomSymbol];
        }

        return randomGrid;
    }

    public isFirstPickBonus(spinRecord: SpinRecord) {
        const bonusResults = spinRecord.getResultsOfType(BonusResult);
        const noBonusResultsHaveCompleted = bonusResults.filter((result) => result.played).length === 0;
        return noBonusResultsHaveCompleted;
    }

    public isSecondPickBonus(spinRecord: SpinRecord) {
        const bonusResults = spinRecord.getResultsOfType(BonusResult);
        const anMCBonusHasCompleted = bonusResults.filter((result) => result.played).length > 0;
        const hasGatewayResult = spinRecord.getResultsOfType(BonusResult).length > 0;

        return anMCBonusHasCompleted && hasGatewayResult;
    }

    private getChildFeature(spin: AGSSpinSchema) {
        return spin.childFeature as HoldAndSpinSchema[];
    }

    private updateGridWithMcSymbols(spinRecord: SpinRecord, spin: AGSSpinSchema, grid: string[][]) {
        const childFeature = this.getChildFeature(spin);
        let startIndex = this.getIndexOfSecondGame(childFeature);

        if (this.isFirstPickBonus(spinRecord)) {
            this.addBaseGameMCSymbolsToGrid(spin, grid);
            startIndex = 0;
        }

        // Adding mc symbols from previous picks.
        for (let i = startIndex; i < childFeature.length; i++) {
            childFeature[i].MCSymbols.forEach((mcSymbol) => {
                const index = getReelIndexFromCoordinate(mcSymbol);
                grid[index][0] = `TT_${mcSymbol.symbol}`;
            });
        }
    }

    private addBaseGameMCSymbolsToGrid(spin: AGSSpinSchema, grid: string[][]) {

        if (!spin.MCSymbols) {
            return grid;
        }

        spin.MCSymbols.forEach((symbol) => {
            const symbolX = symbol.coordinate[0] * this.reelHeight;
            const symbolY = symbol.coordinate[1];
            const reelIndex = symbolX + symbolY;
            grid[reelIndex][0] = `TT_${symbol.symbol}`;
        });
    }

    private getIndexOfSecondGame(childFeature: HoldAndSpinSchema[]) {
        let startOfSecondGame = -1;

        const mcPicks = childFeature.filter((child) => child.type === "pick");
        mcPicks.forEach((mcSymbol, index) => {

            if (startOfSecondGame >= 0) {
                return;
            }

            const hasMoreMcPicks = mcPicks.length - 1 > index;

            if (mcSymbol.complete) {
                if (hasMoreMcPicks) {
                    startOfSecondGame = index + 1;
                }
            }
        });

        return startOfSecondGame === -1 ? 0 : startOfSecondGame;
    }
}

export default new MCPickRecordGridGenerator();
